import React from "react";
import {observer} from "mobx-react";

import "./legend-item-group.scss";

import {Header, Icon, Table} from "semantic-ui-react";
import {LegendItemGroupConfiguration} from "../../../../../../../config/legend-configuration";
import {LegendListItem} from "./legend-list-item/legend-list-item";

interface LegendItemGroupProps {
    config: LegendItemGroupConfiguration;
}

@observer
export class LegendItemGroup extends React.Component<LegendItemGroupProps, any> {

    constructor(props: LegendItemGroupProps) {
        super(props);
    }

    componentDidMount(): void {
    }

    componentWillUnmount(): void {
    }

    render(): React.ReactElement | null {
        if (!this.props.config.items) {
            return null;
        }

        const items = this.props.config.items.map((item) =>
            <LegendListItem config={item} key={item.id}/>
        );
        const {link} = this.props.config;
        const hasLink = link != null && link.title != null && link.url != null;

        return (
            <div className="geo-legend-item-group">
                <Header size="tiny" className="geo-legend-item-group-heading">
                    <Header.Content>
                        {this.props.config.title}
                    </Header.Content>
                    {hasLink &&
                        <Header.Subheader>
                            <a href={link?.url} target="_blank" rel="noreferrer" className="external">
                                {link?.title}
                                <Icon name="external alternate" size="small" />
                            </a>
                        </Header.Subheader>
                    }
                </Header>
                <Table basic="very" size={"small"} celled collapsing unstackable>
                    <Table.Body>
                        {items}
                    </Table.Body>
                </Table>
            </div>
        );

    }
}
